import { Injectable } from '@angular/core';
import { IBulkItem } from '../../src/typings/models';
import { IBulkActionService } from '../../src/typings/services';
import { IdentifiableService } from '../identifiable/IdentifiableService';
import { SelectableService } from '../selectable/SelectableService';


@Injectable({
    providedIn: 'root'
})
export class BulkActionService implements IBulkActionService {
    public static $name = 'bulkActionService';

    constructor(
        private identifiableService: IdentifiableService,
        private selectableService: SelectableService
    ) {
    }

    changeAllSelection<T>(items: IBulkItem<T>[]) {
        if (this.selectableService.hasAllSelected(items)) {
            items.forEach((item) => item.selected = false);
            return;
        }

        items.forEach((item) => item.selected = true);
        return;
    }

    getCurrentCheckboxIcon<T>(items: IBulkItem<T>[]): string {
        if (this.selectableService.hasAllSelected(items)) {
            return 'check_box';
        }

        if (this.selectableService.hasSelected(items)) {
            return 'indeterminate_check_box';
        }

        return 'check_box_outline_blank';
    }

    public getBulkIds<T>(items: Array<IBulkItem<T>>): T[] {
        let selectedItems = this.selectableService.getSelected(items);
        let ids = this.identifiableService.getIds(selectedItems);
        return ids;
    }
}
